module.exports = __webpack_public_path__ + "media/icons/offer-details-budowlane@2x-64c294a4.png";